export { ProductAvailabilityIndicator } from './ProductAvailabilityIndicator'
